/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useMemo, useState } from 'react';

import { CssVariablesReaderContext } from '@xanadu/ui-shared/contexts/CssVariablesReaderContext';

import styles from './BurgerMenuButton.module.scss';

const BurgerMenuButton = ({ active }) => {
  const getCssVariable = useContext(CssVariablesReaderContext);

  const [animationOngoing, setAnimationOngoing] = useState(false);

  const cssNavigationAnimationTiming = getCssVariable({
    selector: '--tm-floating-navigation-animation',
    format: 'number',
  });

  useEffect(() => {
    let animationTimeout = null;
    setAnimationOngoing(true);
    animationTimeout = setTimeout(() => {
      setAnimationOngoing(false);
    }, [(cssNavigationAnimationTiming * 3) / 2 + 5]);
    return () => {
      if (animationTimeout) {
        clearTimeout(animationTimeout);
      }
    };
  }, [active]);

  const buttonClass = useMemo(
    () =>
      classNames({
        [styles.btn]: true,
        [styles['not-active']]: animationOngoing && !active,
        [styles.active]: animationOngoing && active,
        [styles['btn--static-closed']]: !animationOngoing && !active,
        [styles['btn--static-open']]: !animationOngoing && active,
      }),
    [animationOngoing, active]
  );

  return (
    <div className={buttonClass || styles['btn--static-closed']}>
      <span />
      <span />
      <span />
    </div>
  );
};

BurgerMenuButton.propTypes = {
  active: PropTypes.bool.isRequired,
};

export default BurgerMenuButton;
